import { ShowReport } from "components/reports/show";
import { viewContainer } from "helpers/redux";
import { REPORT_TYPES } from "helpers/reports";
import React from "react";
import FuelLimitsReport from "./fuelLimitsReport";

class ConfiguredReport extends ShowReport {
    reportComponent = () => FuelLimitsReport;
}

const ReportWrapper = (props) => (
    <div className="page-content">
        <ConfiguredReport {...props} id={REPORT_TYPES.FuelLimitsReport} transition="full" />
    </div>
);

export default viewContainer(ReportWrapper, "reports");
